module.exports = __webpack_public_path__ + "img/77.73fd26f4.jpg";